import { TransactionListItem } from "@common/schemas/transaction.schema";
import { BANK_CASH_ITEM_TYPE_LABELS } from "@common/types/bankCashItem";
import { Tooltip } from "@design-system/Tooltip/Tooltip";
import { BankCheckIcon } from "@icons";
import styles from "./BankDescriptionCell.module.scss";

interface Props {
    transaction: TransactionListItem;
}

export const CashItemIndicator = ({ transaction }: Props) => {
    const cashItem = transaction.cashItem ?? transaction.splitParent?.cashItem;
    if (!cashItem) {
        return null;
    }
    const label = BANK_CASH_ITEM_TYPE_LABELS[cashItem.type];

    return (
        <Tooltip side="top" content={label}>
            <span
                role="img"
                aria-label={label}
                className={styles.cashItemIndicator}
            >
                <BankCheckIcon className="icon-color-gray-700" />
            </span>
        </Tooltip>
    );
};
